import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import type {PlatformPostPreviewProps} from '@Components/social-media/components/social-post-content-multiposting/social-post-content-multiposting.types';
import {getFeedMediaLayout, PreviewMediaFit} from '@Components/social-media/components/social-post-content-multiposting/social-post-content-media-wrapper/social-post-content-media-wrapper.types';
import {PreviewAccountHeader} from '../preview-account-header/preview-account-header';
import {PreviewAccountMetaSkeleton} from '../preview-account-header/components/preview-account-meta-skeleton/preview-account-meta-skeleton';
import {PREVIEW_ACCOUNT_META_BAR_AND_SQUARE} from '../preview-account-header/components/preview-account-meta-skeleton/preview-account-meta-skeleton.types';
import {PreviewClampedCaption} from '../preview-clamped-caption/preview-clamped-caption';
import {PreviewAssetIcon} from '../preview-asset-icon/preview-asset-icon';
import {LINKEDIN_ACTION_ICON_PATHS, LINKEDIN_REACTIONS_ICON_PATH} from './linkedin-post-preview.types';
import styles from './linkedin-post-preview.module.scss';
import {getCaptionWithPlaceholder} from '@Libraries/social-media-params.library';

export function LinkedinPostPreview({account, platformMediaType, publishingParams, numberOfPages, renderMedia}: PlatformPostPreviewProps): ReactElement {
  const getCaptionText = (): string => {
    return getCaptionWithPlaceholder(publishingParams, account.id, platformMediaType);
  };

  const getCaption = (): ReactElement => {
    const captionText = getCaptionText();

    return (
      <PreviewClampedCaption captionText={captionText} textClassName={styles.linkedinCaptionClamp}>
        <Text className={styles.linkedinCaptionText} size={TextSize.XS} val={captionText} />
      </PreviewClampedCaption>
    );
  };

  const getActionIcons = (): ReactElement => {
    return (
      <div className={styles.linkedinActionIcons}>
        {LINKEDIN_ACTION_ICON_PATHS.map((iconPath: string): ReactElement => {
          return <PreviewAssetIcon iconPath={iconPath} key={iconPath} />;
        })}
      </div>
    );
  };

  return (
    <div className={styles.linkedinPost}>
      <div className={styles.linkedinTextBlock}>
        <PreviewAccountHeader account={account} metaRow={<PreviewAccountMetaSkeleton parts={PREVIEW_ACCOUNT_META_BAR_AND_SQUARE} />} trailingAction={null} />
        {getCaption()}
      </div>
      {renderMedia({layout: getFeedMediaLayout(numberOfPages), fit: PreviewMediaFit.COVER, frameClassName: styles.linkedinMediaFrame})}
      <div className={styles.linkedinActionBar}>
        {getActionIcons()}
        <img alt="" aria-hidden="true" className={styles.linkedinReactions} src={window.PMW.util.asset_url(LINKEDIN_REACTIONS_ICON_PATH)} />
      </div>
    </div>
  );
}
